import React, { useEffect, useState, forwardRef } from "react";
import { Dropdown } from "@els/els-react--dropdown";
import { useNavigate } from "react-router-dom";
import { PAGE } from "../../constants/page";
import "../../styles/components/Admin/StateDropDown.scss";
import { API } from "../../constants/api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  ApiCallWithLoader,
  errorUpdate,
} from "../../redux/reducers/LoaderSlice";
import {
  updateStateId,
  selectedStatePractioner,
} from "../../redux/reducers/PractionerRoleIdsSlice";
import { hideSuccessMessage } from "../../redux/reducers/UserSlice";
import { Trans } from "react-i18next";
// const CustomTitle = forwardRef(({ children, onClick }: any, ref: any) => (
//   <span
//     ref={ref}
//     className="stateDropDownTile"
//     onClick={e => {
//       e.preventDefault();
//       onClick(e);
//     }}
//   >
//     {children}
//     <span className="stateDropDownIcon">&#x25bc;</span>
//   </span>
// ));  old customtitle code for old Dropdown Component

interface StateDropDownType {
  title: string;
  activeTabValue: string;
  showViewReportButton?: boolean;
  stateListRedux?: any;
}

const StateDropDown = ({
  title,
  activeTabValue,
  showViewReportButton = true,
  stateListRedux,
}: StateDropDownType) => {
  const [selectedState, setSelectedState] = useState({
    label: "",
    value: "",
  });
  const [stateDetails, setStateDetails] = useState<any>(null);
  const dispatch = useAppDispatch();
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    try {
      setStateDetails(
        stateListRedux?.stateList.map((location: any) => {
          return {
            value: location.resource.id,
            label: location.resource.name,
          };
        })
      );
      const defaultState: any = stateListRedux?.stateList.find(
        (stateDetail: any) =>
          stateDetail.resource.name?.toLowerCase() === title?.toLowerCase()
      );
      setSelectedState({
        label: defaultState?.resource?.name,
        value: defaultState?.resource?.id,
      });
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  }, []);
  useEffect(() => {
    dispatch(updateStateId(selectedState));
  }, [selectedState]);

  const handleStateChange = (stateDetail: any) => {
    const tmpObj = { label: "", value: "" };
    tmpObj.label = stateDetail.label;
    tmpObj.value = stateDetail.id;
    setSelectedState(tmpObj);
    navigateToState(stateDetail.label);
    dispatch(hideSuccessMessage(true));
    (
      document.querySelector('input[id="searchInput"]') as HTMLInputElement
    ).value = "";
  };

  const navigate = useNavigate();
  const navigateToState = (stateName: string) => {
    const routeLink = PAGE.GLOBAL_STATE_ADMIN.replace(
      ":state",
      stateName
    ).concat(`/${activeTabValue}`);
    navigate(routeLink);
  };

  const stateOptions = stateDetails?.map((state: any) => {
    return {
      label: state.label,
      id: state.value.toString(),
    };
  });

  const selectedStateOption = { label: selectedState?.label };

  return (
    <div className="bg-light-gray">
      <div className="container stateDropDownContainer">
        {stateDetails && (
          <Dropdown
            selected={selectedStateOption}
            showSelectedAsLabel={true}
            id="state-select"
            onChange={(e: any) => {
              handleStateChange(e);
            }}
            options={stateOptions}
            flyoutProps={{
              placement: "bottom-start",
              pointer: false,
              pointerType: "primary",
            }}
          />
        )}

        {showViewReportButton && (
          <button
            disabled={disabled}
            className="btn btn-primary posAbs"
            onClick={() => {
              setDisabled(true);
            }}
          >
            <Trans i18nKey={"grid.view_report"} />
          </button>
        )}
      </div>
    </div>
  );
};

export default StateDropDown;
